import { render, staticRenderFns } from "./marca.vue?vue&type=template&id=0c30f476"
import script from "./marca.vue?vue&type=script&lang=js"
export * from "./marca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports